function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import argon2 from 'argon2-browser';
import { AES, enc } from 'crypto-js';
import Utf8 from 'crypto-js/enc-utf8';
import csprng from 'csprng';
import { encrypt, decrypt } from 'libs/RSA';
export { generateKeyPair, generatePrvKeyPem as getPrvKeyPem, generatePubKeyPem as getPubKeyPem, encrypt, decrypt, getKeyFromPem } from 'libs/RSA';
export const generateSecret = (bits = 512, radix = 36)=>csprng(bits, radix);
export const generateHash = async (pass, salt, options = null)=>{
    const defaultOptions = {
        time: 6,
        mem: 16384,
        hashLen: 32
    };
    const hash = await argon2.hash(_object_spread({
        pass,
        salt
    }, defaultOptions, options));
    return hash.hashHex;
};
export const decodeToHex = (base64Text)=>enc.Hex.stringify(enc.Base64.parse(base64Text));
//----------------------------------------------------------------------------------------------------------------------
export const symmetricEncrypt = (text, secret)=>AES.encrypt(text, secret).toString();
export const symmetricDecrypt = (hex, secret)=>{
    try {
        return AES.decrypt(hex, secret).toString(Utf8);
    } catch (err) {
        return null;
    }
};
//----------------------------------------------------------------------------------------------------------------------
export const hybridEncrypt = async (text, pubKeyObj)=>{
    const secret = generateSecret();
    const encryptedSecret = await encrypt(secret, pubKeyObj);
    const hex = symmetricEncrypt(text, secret);
    return `${hex}||${encryptedSecret}`;
};
export const hybridDecrypt = async (hybridHex, prvKeyObj)=>{
    const [hex, encryptedSecret] = hybridHex.split('||');
    const secret = await decrypt(encryptedSecret, prvKeyObj);
    return symmetricDecrypt(hex, secret);
};
